import ListButton from '../ListButton/ListButton'
import {
  BodyWrapper,
  FormWrapper,
  HeaderList,
  ListWrapper,
  Modal,
  RemoveAllButton,
  SearchWrapper,
  TitleList,
} from './styles'
import ModalAddAutoAssignMemberHook from './ModalAddAutoAssignMember.hook'

import AutoCompleteSearchUser from './components/AutoCompleteSearchUser/AutoCompleteSearchUser'

const ModalAddAutoAssignMember = () => {
  const { isVisible, buttonProps, onSubmit, onCancelFunction, userValue, setUserValue } =
    ModalAddAutoAssignMemberHook()

  return (
    <Modal
      title="เพิ่มผู้ใช้งาน"
      open={isVisible}
      closable={false}
      cancelText="ยกเลิก"
      okText="เพิ่ม"
      okButtonProps={buttonProps}
      onOk={onSubmit}
      onCancel={onCancelFunction}
      width={400}
      data-testid="add-assign-member-modal"
    >
      <SearchWrapper>
        <AutoCompleteSearchUser
          userValue={userValue}
          onChangeUser={(e) => setUserValue(e)}
          data-testid="add-assign-member-search-input"
        />
      </SearchWrapper>
      <FormWrapper>
        <HeaderList>
          <TitleList>จำนวนทั้งหมด {userValue.length} คน</TitleList>
          <RemoveAllButton
            onClick={() => setUserValue([])}
            data-testid="add-assign-member-remove-all-button"
          >
            ลบทั้งหมด
          </RemoveAllButton>
        </HeaderList>
        <BodyWrapper>
          {userValue.length > 0
            ? userValue.map((user) => {
                return (
                  <ListWrapper data-testid={`add-assign-member-user-${user.value}`}>
                    <ListButton
                      text={user.label}
                      onDeleteClose={() => {
                        setUserValue((prevUserValue) =>
                          prevUserValue.filter((u) => u.value !== user.value),
                        )
                      }}
                    />
                  </ListWrapper>
                )
              })
            : null}
        </BodyWrapper>
      </FormWrapper>
    </Modal>
  )
}

export default ModalAddAutoAssignMember
